import React from "react";

import { useLanguage } from "@/contexts/LanguageContext.jsx";
import LegalDocumentPage from "@/pages/legal/LegalDocumentPage.jsx";
import { getTermsSections } from "@/pages/legal/legalContent.js";

export default function TermsConditionsPage() {
  const { t } = useLanguage();

  return (
    <LegalDocumentPage
      title={t("legal.terms.title", "Terms & Conditions")}
      subtitle={t(
        "legal.terms.subtitle",
        "The rules for using AfriMed™ services, including account use, service access, platform conduct, and legal responsibilities.",
      )}
      effectiveDate={t("settlement.termsEffectiveDate", "September 21, 2026")}
      sections={getTermsSections(t)}
      siblingLink={{ to: "/legal/privacy", label: t("common.legal.privacy", "Privacy Policy") }}
      extraLinks={[{ to: "/legal/data-deletion", label: t("common.legal.dataDeletion", "Data Deletion") }]}
    />
  );
}
